import { ProfileApiModel } from "src/shared/models/dashboard.model";

export class BroadcastProfileApiModel implements ProfileApiModel {
    ProfileID: number;
    CompanyID: number;
    ProfileName: string;
    GroupID: number;
    GroupLevel: number;
    GroupType: number;
    GroupTypeStr: string;
    pristineSend: boolean;
    send: boolean;

    constructor(profile: ProfileApiModel) {
        this.ProfileID = profile.ProfileID;
        this.CompanyID = profile.CompanyID;
        this.ProfileName = profile.ProfileName;
        this.GroupID = profile.GroupID;
        this.GroupLevel = profile.GroupLevel;
        this.GroupType = profile.GroupType;
        this.GroupTypeStr = profile.GroupTypeStr;
        this.pristineSend = false;
        this.send = false;
    }
};
